// Module
var code = "<template> <require from=\"./brygg-container.css\"></require> <div class=\"b-container-outer\"> <div class=\"b-container-inner\" css=\"min-width: calc(min(100%, ${minWidth}))\"> <slot></slot> </div> </div> </template> ";
// Exports
export default code;